import { render } from "./AddEditDealer.vue?vue&type=template&id=5af22b6c&scoped=true"
import script from "./AddEditDealer.vue?vue&type=script&lang=js"
export * from "./AddEditDealer.vue?vue&type=script&lang=js"

import "./AddEditDealer.vue?vue&type=style&index=0&id=5af22b6c&scoped=true&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af22b6c"]])

export default __exports__